import { useCallback, useState } from 'react';
import { Routes, Route } from 'react-router-dom';

import './App.scss';
import Checkout from './components/Checkout/Checkout';
import { Slider } from './components/Slider/Slider';
import { PaymentStatus } from './pages/PaymentStatus/PaymentStatus';
import { CheckoutContextAdapter } from './providers/CheckoutContextAdapter';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorFallbackRender } from './components/Checkout/components/ScreenLock/ScreenLock';
import { HandlePayment } from './pages/HandlePayment/HandlePayment';
import { AppConfigProvider } from './providers/AppConfigProvider';
import { Handshake } from './pages/Handshake/Handshake';
import { APMDynamicPage } from './pages/APMDynamicPage/APMDynamicPage';
import { ForterProvider } from './providers/Forter';
import { startMeasuringPerformance } from './utils/performance-utils';
import { Subscriptions } from './pages/Subscriptions/Subscriptions';

export default function App() {
  startMeasuringPerformance();
  const [showCheckout, setShowCheckout] = useState(true);
  const onClose = useCallback(() => setShowCheckout(false), []);

  return (
    <ErrorBoundary FallbackComponent={ErrorFallbackRender}>
      <div className="App">
        <Routes>
          <Route path="/handshake" element={<Handshake />} />
          <Route path="/apm-dynamic-page" element={<APMDynamicPage />} />
          <Route path="/status/:sessionId/:orderId" element={<PaymentStatus />} />
          <Route path="/handle-payment/:clientSecret/:pk" element={<HandlePayment />} />
          <Route
            path="/subscriptions/:sessionToken"
            element={
              <AppConfigProvider>
                <ForterProvider>
                  <CheckoutContextAdapter provider="subscription">
                    <Slider open={showCheckout}>
                      <Subscriptions onClose={onClose} />
                    </Slider>
                  </CheckoutContextAdapter>
                </ForterProvider>
              </AppConfigProvider>
            }
          />
          <Route
            path="*"
            element={
              <AppConfigProvider>
                <ForterProvider>
                  <CheckoutContextAdapter provider="checkout">
                    <Slider open={showCheckout}>
                      <Checkout onClose={onClose} />
                    </Slider>
                  </CheckoutContextAdapter>
                </ForterProvider>
              </AppConfigProvider>
            }
          />
        </Routes>
      </div>
    </ErrorBoundary>
  );
}
